import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Menu, { MenuProps } from '@material-ui/core/Menu'

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    paddingLeft: 20,
    paddingRight: 20,

    boxShadow:
      'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

export { StyledMenu }
